/**
 * Excel 模板提取模块统一出口。
 *  - extractTemplate：纯逻辑（wb → 骨架），样式依赖外部传入（styleIndex/styles）
 *  - xlsx 系列：zip / styles.xml / theme1.xml / sheet XML 解析 + 一站式 extractTemplateFromBuffer
 */
export { extractTemplate } from './extract.js';
export type {
  TemplateSkeleton,
  SkeletonCell,
  StyleBorder,
  ExtractOptions,
  ResolvedStyles,
  ResolvedFont,
  ResolvedFill,
  ResolvedBorder,
  ResolvedBorderPart,
  ResolvedColor,
  ResolvedAlignment,
  ResolvedXf,
} from './extract.js';
export {
  extractTemplateFromBuffer,
  parseZip,
  parseStylesXml,
  parseThemeXml,
  parseSheetStyleIndexes,
} from './xlsx.js';
export type { TemplateBlock, Zone, Side } from './regions.js';
export { segmentBlocks } from './regions.js';
export type { DataCellCandidate } from './detectSlots.js';
export { detectDataSlots } from './detectSlots.js';
export type { BindingDict, BindingDictEntry, BindingSuggestion } from './bindingDict.js';
export { BindingDictLoader, getBindingDictLoader, suggestBindings } from './bindingDict.js';
export { dedupeListBindings } from './dedupeListBindings.js';
export type { DedupeStats } from './dedupeListBindings.js';
export type { FieldSuggestion, FieldType, ScoringContext } from './scorer.js';
export {
  scoreFieldSuggestions,
  batchScoreDataCells,
  USER_BIND_ANCHOR_THRESHOLD,
} from './scorer.js';
export { mergeBindingDicts, getMergeStats } from './binding-dict-merger.js';
